import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const TableDivider = ({
  withSidePadding = false,
}: {
  withSidePadding?: boolean;
}) => (
  <TableRow>
    <TableCell
      colSpan={2}
      sx={{
        borderBottom: "none",
        py: 0,
        px: withSidePadding ? 2 : 0,
      }}
    >
      <Box sx={{ height: 2, my: 1, backgroundColor: "divider" }} />
    </TableCell>
  </TableRow>
);

export default TableDivider;
